import {
  B_13,
  BANNER_DEFAULTS,
  hideB13Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B13_PLASMIC_PROPS = {
  b13Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_13].heading,
    description: "Main heading (B13 only)",
    hidden: hideB13Props,
  },
  b13Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_13].description,
    description: "Description text (B13 only)",
    hidden: hideB13Props,
  },
  b13PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_13].primaryButtonText,
    description: "Primary CTA button text (B13 only)",
    hidden: hideB13Props,
  },
  b13PrimaryButtonUrl: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_13].primaryButtonUrl,
    description: "Primary CTA button URL (B13 only)",
    hidden: hideB13Props,
  },
  b13MobileImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_13].mobileImg,
    description: "Mobile/tablet image (B13 only)",
    hidden: hideB13Props,
  },
  b13DesktopImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_13].desktopImg,
    description: "Desktop image (B13 only)",
    hidden: hideB13Props,
  },
  b13ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_13].imageAlt,
    description: "Image alt text for desktop and mobile (B13 only)",
    hidden: hideB13Props,
  },
};
